import React from 'react'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import styles from './styles.module.sass'
import FormControl from 'react-bootstrap/FormControl'

const TextArea = ({
  values,
  handleChange,
  touched,
  errors,
  label,
  className,
  showNotApprovedMessage,
  placeholder,
  type = 'textarea',
  formName,
  noResize = false,
  isTextarea = false,
}) => {
  let additionalProps = {}
  if (isTextarea) {
    additionalProps.as = 'textarea'
  }
  return (
    <Form.Group as={Col} xs="12" controlId="name" className={styles.textAreaContainer}>
      <Form.Label>{label}</Form.Label>
      <FormControl
        style={ noResize ? {resize: 'none'} : {}}
        as="textarea"
        className={className}
        placeholder={placeholder}
        type={type}
        name={formName}
        value={values[formName] || ''}
        onChange={handleChange}
        isValid={touched[formName] && !errors[formName]}
        {...additionalProps}
      />
        { showNotApprovedMessage && <span className={styles.warningText}>Čeka se odobrenje admina</span>}
    </Form.Group>
  )
}
export default TextArea
